<div *ngIf="typeList && dataCategories">
  <br />
  <br />

  <p-select
    ngDefaultControl
    [placeholder]="'type' | translation"
    [options]="typeList"
    [(ngModel)]="selectedType"
    optionLabel="name"
    appendTo="body"
  />

  <p-select
    [placeholder]="'category' | translation"
    *ngIf="!selectedType"
    [disabled]="true"
    appendTo="body"
  />

  <p-select
    (onChange)="updateCategory()"
    ngDefaultControl
    *ngIf="selectedType"
    [placeholder]="'category' | translation"
    [options]="dataCategories"
    [(ngModel)]="selectedType.category"
    optionLabel="title"
    optionValue="id"
    appendTo="body"
  />
</div>
